import React, { useState } from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';
import CompliancePeriodBar, { currentFy } from '../../components/admin/compliance/CompliancePeriodBar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const DEFAULT_FY = currentFy();

function buildParams(period, fy) {
  const params = { period };
  if (period === 'fy') params.fy = fy;
  return params;
}

export default function ComplianceCaExports() {
  const [period, setPeriod] = useState('fy');
  const [fy, setFy] = useState(DEFAULT_FY);
  const [busy, setBusy] = useState(null);

  const download = async (path, filename) => {
    setBusy(path);
    try {
      const r = await axios.get(`${API}${path}`, {
        withCredentials: true,
        params: buildParams(period, fy),
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert(e?.response?.data?.detail || 'Export failed');
    } finally {
      setBusy(null);
    }
  };

  const exports = [
    { label: 'Commission TDS report (CSV)', path: '/reports/commission-tds/csv', file: 'commission_tds.csv' },
    { label: 'Commission GST summary (CSV)', path: '/reports/commission-gst/csv', file: 'commission_gst.csv' },
    { label: 'GSTR-7 TDS prep (JSON)', path: '/reports/tds-gstr7', file: 'gstr7.json', json: true },
    { label: 'Finance ledger bulk (JSON)', path: '/reports/finance-ledger/export', file: 'finance_ledger.json', json: true },
    { label: 'CA package bundle (JSON)', path: '/reports/ca-package', file: 'ca_package.json', json: true },
    { label: 'Production baseline snapshot (JSON)', path: '/commission/baseline-export', file: 'baseline.json', json: true, noPeriod: true },
  ];

  const handleExport = async (item) => {
    if (item.json) {
      setBusy(item.path);
      try {
        const params = item.noPeriod ? {} : buildParams(period, fy);
        const r = await axios.get(`${API}${item.path}`, { withCredentials: true, params });
        const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = item.file;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        alert(e?.response?.data?.detail || 'Export failed');
      } finally {
        setBusy(null);
      }
      return;
    }
    await download(item.path, item.file);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900">CA Exports</h2>
        <p className="text-sm text-gray-500">Download compliance packages for your CA</p>
      </div>
      <CompliancePeriodBar
        period={period}
        onPeriodChange={setPeriod}
        fy={fy}
        onFyChange={setFy}
      />
      <div className="grid gap-3">
        {exports.map((item) => (
          <button
            key={item.path}
            type="button"
            disabled={busy === item.path}
            onClick={() => handleExport(item)}
            className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-4 py-3 hover:bg-gray-50 text-left"
          >
            <span className="font-medium text-gray-900">{item.label}</span>
            <Download className="w-4 h-4 text-gray-500" />
          </button>
        ))}
      </div>
    </div>
  );
}
